// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactItem_wrapper__qCKO6","logo":"ContactItem_logo__gA2LG"};